module.exports = __webpack_public_path__ + "static/media/userTokenWarning.11a8ac2f.svg";